module.exports = __webpack_public_path__ + "img/qghj2_25_10.prt.994cb4a2.jpg";